import { Column, Divider, Loader, Modal, Row, Text } from "@gradience/ui";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { useApiQuery } from "../../../lib/api";
import displayDate from "../../../lib/display-date";
import { displayCurrency } from "../../../lib/display-currency";
import { useSelectedTest } from "../../../domain/use-latest-test";

export const PaymentsModal = () => {
  const search = useSearch({ from: "/$test-slug/home/" });
  const navigate = useNavigate({ from: "/" });
  const test = useSelectedTest();

  const paymentsQuery = useApiQuery(
    "/registrations/:testId/payments",
    {
      testId: test.data?.id ?? "",
    },
    { enabled: test.data?.id !== undefined }
  );

  const onClose = () =>
    navigate({ search: (prev) => ({ ...prev, modal: undefined }) });
  const isOpen = search.modal === "payments";

  return (
    <Modal open={isOpen} close={onClose}>
      {paymentsQuery.isPending ? (
        <Loader />
      ) : (
        <Column gap={24}>
          <Column gap={6}>
            <Text textStyle="24px - Bold">Payments</Text>
            <Text textStyle="14px - Medium">
              View registration payments below. Click on a date to export the
              receipt.
            </Text>
          </Column>
          <Column gap={8}>
            {paymentsQuery.data?.data.map((payment) => (
              <>
                <Row key={payment.date}>
                  <a
                    href={payment.receiptUrl}
                    target="_blank"
                    style={{ flex: 1, textDecoration: "none" }}
                    rel="noreferrer"
                  >
                    <Text textStyle="14px - Bold">
                      {displayDate(payment.date)}
                    </Text>
                  </a>
                  <Text textStyle="14px - Medium">
                    {displayCurrency(payment.amount)}
                  </Text>
                </Row>
                <Divider />
              </>
            ))}
          </Column>
        </Column>
      )}
    </Modal>
  );
};
